/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, createRef, useState, useEffect} from "react";
import { connect } from "react-redux";
import { Helpers, Redux, Templates } from "@ora/recursos";

import axios from "axios";
import { Link } from "react-router-dom";
import Graficosv4 from './Graficosv4';


const { set_datapage, getMapStateDefault } = Redux.Actions.DataPageAction;
const { baseUrl, baseUrlModule, localUrl } = Helpers.Url;
const { checkDataDirectorio, seDatatDocumentos } =
  Redux.Actions.DirectoriosActions;

const VIEW_SESSION_NAME = "NOMBRE_UNICO_PARA_LAVISTA_ACTUAL_PUBLIC";

class Dashboardv4 extends Component {
  refSelectPresentacion= null
  refSelectGrupos = null
  refSelectOrigen=null

  requestInit = null;
  requestInitTypeHead = null;  
  state = {
    presentacion:[],
    especies:[],
    especiesSelect: [],
    grafico:[],
    terminos:[],
    grupos:[],
    term:-1,
    group:-1,

    op:'',
    bycountrie:[],
    ocountrie:[],
    species:[],
    eleccion:[],
    typeinfo:'',
    especiest:'-1',
    famactive:-1,
    count:'',
    type_info:[],
    status:false,
  };


  requestInitTypeHead = []
  constructor(props) {
    super(props);

    this.requestInit = axios.CancelToken.source();
    let objFinal = {};
    //opcional
    // this.props.checkDataDirectorio(VIEW_SESSION_NAME).then((resCheck) => {
    //   if (!resCheck.success) {
    //     this.__getDataInitial();
    //   } else {
    //     this.initpage(resCheck.data);
    //   }
    // });

    objFinal={
      filtersTabOne: {
        grupo: -1,
        fami:0,
      },
      presentacion:[],
      grafico:[],
      terminos:[],
      eleccion:[],
      grupos:[],
      bycountrie:[],
      ocountrie:[],
      species:[],
      count:'',
      op:'',
      term:-1,
      group:-1,
      especiest:'-1',
      typeinfo:'',
      type_info:[],
      famactive:-1,
      currentDataEspecie: {
        pli_txt_scientificname: '',
        imageDefault: '',
      },
      especiesSelect: [],
              currentDataEspecie: {
              pli_txt_scientificname: '',
              imageDefault: '',
              pli_txt_commonnames_f: '',
              pli_txt_cite_f: '',
              pli_txt_uicn: '',
              pli_txt_taxonid: '',


              pli_txt_kingdom: '',
              pli_txt_phylum: '',
              pli_txt_class: '',
              pli_txt_order: '',
              pli_txt_family: '',
              pli_txt_genus: ''
            }
    }

    this.state = objFinal

      this.refSelectPresentacion = createRef()
      this.refSelectGrupos = createRef()
      this.refSelectOrigen = createRef();
    //opcional
    // this.props.checkDataDirectorio(VIEW_SESSION_NAME).then((resCheck) => {
    //   if (!resCheck.success) {
    //     this.__getDataInitial();
    //   } else {
    //     this.initpage(resCheck.data);
    //   }
    // });
  }

  __getDataInitial() {
    axios
      .get(baseUrlModule("listaprueba"), {
        params: {
          // especie: this.props.especie.pli_int_id,
          // id: this.props.especie.pli_int_id,
          // onlyquery: false,
          // variables_distribution: this.variables_distribution
        },
        cancelToken: this.requestInit.token,
      })
      .then((res) => {
        if (res.data.success) {
          let _preData = {
            session: VIEW_SESSION_NAME,
            data: res.data.data,
            time: Date.now(),
          };
          this.props
            .seDatatDocumentos(_preData)
            .then((resSet) => {
              this.initpage(_preData);
            })
            .catch((err) => {});
        }
      });
  }

  initpage(result) {
    //DATOS NECESARIOS PARA LA VISTA POR DEFECTO, SOLO SI FUERAN ENCESARIOS
    // this.setState({
    //   lista: result.data,
    // });
  }
  componentDidMount() {
    this.setDataPage();
    this.refSelectGrupos.current.value = "-1";
    this.refSelectPresentacion.current.value="-1";
    axios.get(baseUrlModule('reportes/initdashboardv4')).then((res) => {    
      var result=res.data;
      this.setState({
        presentacion:result.presentacion,
        grupos:result.grupos,
        status:true
      });
    });
  }



  /* COMBOS */

  COptionsPresentacion = () => {
    return this.state.presentacion.filter((item)=>(item.tipo==this.state.typeinfo)).map((item)=>{
      return (
        <option value={item.exp_txt_term}>{item.presentacion}</option>
      );
    })
  }

  CoptionsGrupos=()=>{
    return this.state.grupos.filter((item)=>(item.exp_txt_term==this.state.term && item.tipo==this.state.typeinfo)).map((item)=>{
      return (
        <option value={item.cgs_int_id}>{item.cgs_txt_name}</option>
      );
    })
  }


  componentWillUnmount() {
    if (this.requestInit) this.requestInit.cancel();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (100 === +this.props.countDataPage) {
      this.setDataPage();
    }
  }

  examplePost = () => {
    let data = {};
    axios
      .post(baseUrl("aro/downloads"), data, {
        cancelToken: this.requestInit.token,
      })
      .then((resCre) => {});
  };

  setDataPage = () => {
    this.props.set_datapage({
      titulo: this.props.language('dashboar_citesv4_título'),
      isbackend: false,
      hasBreadcrumb: false,
      hasHeroBar: true,
      be_itemselect: "exportaciones_cites", //clave de item del menu backend que se debe activar
      breadcrumb: [
        { name: "Inicio", url: localUrl("/") },
        { name: "Reportes", url: "#" },
        { name: "Biodiversidad", url: "#", active: true },
      ],
    });
  };

  urlWithPublicToken = () => {
    return baseUrl(
      `nombremoduloejemplo/public/anyword?token=${Helpers.ValidationAuth.getPublicAuthorization()
        .replace("Basic", "")
        .replace(" ", "")
        .trim()}`
    );
  };
  render() {
    const handleChange=(event)=> {
      this.setState({
        typeinfo: event.target.value,
        group:-1,
        term:-1

      });
      this.refSelectGrupos.current.value = "-1";
      this.refSelectPresentacion.current.value = "-1";
    
    }

    const handleChange2=(event)=> {
      this.setState({
        term: event.target.value,
        group:-1
      });
      this.refSelectGrupos.current.value = "-1";
    
    }

    const handleChange3=(event)=> {
      this.setState({
        group: event.target.value,
      });
    
    }
    return (
      <Templates.Default.BasePageRoute2
      localUrl={localUrl}
      dataPage={this.props.DataPage}
    >

        <div>
          {this.state.op}
          <section className="section pb-0">
          <div className="columns is-vbottom">
            <div className="column is-2">
              <div className="field">
                <label className="label">
                  {this.props.language('dashboar_citesv2_origendatos')}
                </label>
                <div className="control is-expanded">
                  <span className="select is-empty is-fullwidth">
                    <select  
                    ref={this.refSelectOrigen}
                    onChange={(event) => handleChange(event)}                       
                     disabled={
                        this.state.presentacion.length === 0
                      }
                      defaultValue="-1">
                     <option value="-1">
                       -- {this.props.language("sel_todos")}--
                     </option>
                       {/* <option value="-1">-- Seleccione--</option> */}
                       <option value="exports_cites.org">CITES.ORG</option>
                       <option value="exports_otca">Instituciones Oficiales de los Países Miembros</option>
                    </select>
                  </span>
                </div>
              </div>
            </div>
            <div className="column is-4">
              <div className="field">
                <label className="label">
                  {this.props.language('tipo_presentacion')}
                </label>
                <div className="control is-expanded">
                  <span className="select is-empty is-fullwidth">
                    <select
                    ref={this.refSelectPresentacion}
                      onChange={(event) => handleChange2(event)}
                      disabled={
                        this.state.presentacion.length === 0
                      }
                      defaultValue="-1"
                    
                    >
                       {/* <option value="-1">-- Seleccione--</option> */}
                       <option value="-1">
                          -- {this.props.language("sel_todos")}--
                        </option>

                        {this.COptionsPresentacion()}
                        
                    </select>
                  </span>
                </div>
              </div>
            </div>

            <div className="column is-3">
                              <div className="field">
                                <label htmlFor="sel_especies" className="label">
                                  {this.props.language("dash_cites_grupo", "Grupos")}
                                </label>
                                <div className="control is-expanded">
                                  <span className="select is-empty is-fullwidth">
                                    <select
                                    ref={this.refSelectGrupos}

                                      onChange={(event) => handleChange3(event)}
                                      disabled={
                                        this.state.presentacion.length === 0
                                      }
                                      defaultValue="-1"
                                    >
                                      <option value="-1" {...this.state.group==-1? <>selected</>:<></>}>
                                        --
                                        {this.props.language(
                                          "seleccionar",
                                          "Seleccionar"
                                        )}
                                        --
                                      </option>
                                      {this.CoptionsGrupos()}
                                      
                                    </select>
                                  </span>
                                </div>
                              </div>
                            </div>

                                      {this.state.status ?
              <></>:<Helpers.Spinners.SpinLoaderStyle/> }


          </div>

          </section>
          <section className="section pb-0">
            <div className="container">

            {this.state.typeinfo!=='' && +this.state.term==-1 && +this.state.group==-1 ?

              <Graficosv4 origen={this.state.typeinfo}  date='1' language={this.props.language}></Graficosv4>

              :<></> }

            {this.state.typeinfo!=='' && +this.state.term!==-1 && +this.state.group==-1 ?

            <Graficosv4 origen={this.state.typeinfo} presentacion={this.state.term} date='2' language={this.props.language}></Graficosv4>

            :<></> }

            {this.state.typeinfo!=='' && +this.state.term!==-1 && +this.state.group!==-1 ?

            <Graficosv4 origen={this.state.typeinfo} presentacion={this.state.term} grupos={this.state.group} date='3' language={this.props.language}></Graficosv4>

            :<></> }






            </div>
          </section>

        </div>

    </Templates.Default.BasePageRoute2>
    );
  }
}

export default connect(getMapStateDefault(), {
  set_datapage,
  seDatatDocumentos,
  checkDataDirectorio,
})(Dashboardv4);
